import { glossaryProcessor } from './glossary-lookup';
import {
  IInterpolationCache,
  ILangProvider,
  ILanguageInterpolator,
  ILanguageResourcesCollection,
  ILanguageServer
} from './interfaces';
import { defaultLanguage } from './consts';
import { globalLanguageDebugMode } from './global-language-debug';

export class GlobalLanguage {
  public languageServer: ILanguageServer;
  public languageInterpolator: ILanguageInterpolator;
  public languageProvider: ILangProvider;
  public interpolationCache: IInterpolationCache;
  public languageCollection: ILanguageResourcesCollection;
}

//this allows us to have a singleton across script boundaries that
//have their own verision of the
globalThis.globalLanguage = globalThis.globalLanguage || new GlobalLanguage();

export function changeLanguage(language?: string): void {
  // const reload = language !== undefined;
  language ??= sessionStorage.getItem('language') ?? localStorage.getItem('language') ?? defaultLanguage;

  const languages = globalThis.globalLanguage.languageServer.getLanguages();
  if (!languages.includes(language)) {
    throw new Error(`Language ${language} is not available.`);
  }
  globalThis.globalLanguage.languageProvider.currentLanguage = language;
  document.body.setAttribute('lang', language);
  sessionStorage.setItem('language', language);
  globalThis.dealerConfiguration?.litApp?.updateLogoTemplate?.();
  globalThis.dealerConfiguration?.litApp?.requestUpdate?.();
  window.dispatchEvent(new CustomEvent('language-changed', { detail: { language } }));
  //if (reload) window.location.reload();
}

export function getDefaultLanguage(): string {
  const language = localStorage.getItem('language') || defaultLanguage;
  return language;
}

export function setDefaultLanguage(language: string): void {
  if (!language) {
    throw new Error('Language cannot be empty');
  }
  localStorage.setItem('language', language);
  sessionStorage.setItem('language', language);
  changeLanguage(language);
}

export const globalLanguage = globalThis.globalLanguage as GlobalLanguage;

export function interpolate(
  localizedId: string,
  parameters: object | null = null,
  segmentName: string | null = null
): string {
  const result = globalLanguage.languageInterpolator.getInterpolated(localizedId, parameters, segmentName);
  return globalLanguageDebugMode() ? '<*' + result + '*>' : result;
}

/**
 *
 * @returns interpolated data processing any glossary terms that may be present
 *
 */

export function interpolateExternal(value: string | null | undefined, resourceCollectionName: string = 'v6db'): string {
  if (!value) {
    return '';
  }
  const result = globalLanguage.languageInterpolator.getExternalInterpolatedValue(value, resourceCollectionName);

  return globalLanguageDebugMode() ? '<*' + result + '*>' : result;
}

export function glossary(key: string, optionValue?: string) {
  const result = glossaryProcessor(globalLanguage.languageProvider, key, optionValue);
  return result;
}
